import { KeyRound, LoaderCircle } from "lucide-react";
import { type FormEvent, useState } from "react";
import { useAuth } from "./auth-context";

export function LoginPage({ onAuthenticated }: { onAuthenticated: () => void }) {
  const { login } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const [password, setPassword] = useState("");

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await login(password);
      setPassword("");
      onAuthenticated();
    } catch (loginError) {
      setError(loginError instanceof Error ? loginError.message : "登录失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="app-login">
      <form className="app-login-panel" onSubmit={(event) => void handleSubmit(event)}>
        <div className="app-login-icon">
          <KeyRound aria-hidden="true" size={24} />
        </div>
        <div>
          <span>HOLO CARGO</span>
          <h1>场景项目管理</h1>
          <p>输入访问密码后进入项目、场景编辑和设备模型管理。</p>
        </div>
        <label>
          <span>访问密码</span>
          <input
            disabled={busy}
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            value={password}
          />
        </label>
        <button disabled={busy || !password} type="submit">
          {busy ? <LoaderCircle aria-hidden="true" size={18} /> : null}
          {busy ? "验证中" : "进入系统"}
        </button>
        {error ? <p className="app-login-error">{error}</p> : null}
      </form>
    </main>
  );
}
